import { createClient } from '@supabase/supabase-js';

const URL = process.env.REACT_APP_SUPABASE_URL  || '';
const KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const isConfigured = !!(URL && KEY);

// Use placeholder values when not configured so createClient doesn't throw.
// All db.js functions check isConfigured before making any actual calls.
export const supabase = createClient(
  URL || 'https://placeholder.supabase.co',
  KEY || 'placeholder-anon-key',
);
